export class ModalStructure {
    constructor(){
        this.popupModal = '.popupModal';

        let modals = document.querySelectorAll(this.popupModal);
        modals.forEach((modal) => {
            modal.insertAdjacentElement('afterend', this.createBlackout());
            modal.appendChild(this.createClose());
        });
    };

    createBlackout() {
        let column = document.createElement('div');
        column.classList.add('body-blackout');

        return column;
    }

    createModalBody(){
        let body = document.createElement('div');
        body.classList.add('popupModal__body');

        return body;
    }

    createClose() {
        let close = document.createElement('i');
        close.classList.add('popupModal__close');
        close.innerHTML = '<i class="fas fa-times-circle"></i>';

        return close;
    }
}